export default __webpack_public_path__ + "static/media/documentCamera.2f5477c2.svg";